module.exports = __webpack_public_path__ + "static/media/canada.9b57ce11.svg";